module.exports = __webpack_public_path__ + "files/e8a288f0a9060ecaff039d7bba079385.png";